import { useTranslation } from "react-i18next";
import { HorizontalStack } from "../../Stack";
import { Text } from "@fluentui/react";
import {
  getFormattedDateTime,
  getIcon,
  getSplitDocumentName,
} from "../../../utils";
import { Document } from "../../../models";
import { FC } from "react";

type DocumentNameCardProps = {
  item: Document;
  fileType: any;
  versionStyle?: string;
};

export const DocumentNameCard: FC<DocumentNameCardProps> = ({
  item,
  fileType,
  versionStyle,
}) => {
  const { t } = useTranslation();

  // Safely access metadata and other properties
  const fileTypeValue = item?.metadata?.fileType || item?.fileType || fileType;
  const documentName = item?.rootDocumentName || '';
  const version = item?.version;
  const lastUpdated = item?.lastUpdatedDate;  

  return (
    <>
      <HorizontalStack className="documentName">
        {getIcon(fileType, fileTypeValue)}
        <Text className="dropDownText">
          {getSplitDocumentName(documentName)}
        </Text>
        {version && (
          <Text className={versionStyle}>
            V{version}&nbsp;({t("most_recent")})
          </Text>
        )}
      </HorizontalStack>
      {lastUpdated && (
        <Text className="dateTime">
          {getFormattedDateTime(String(lastUpdated))[0]}
          &nbsp;|&nbsp;
          {getFormattedDateTime(String(lastUpdated))[1]}
        </Text>
      )}
    </>
  );
};
